import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import './Info.css';
import heroVideo from '../assets/prueba.mp4'; // asegúrate de colocar el .mp4 aquí

const careers = [
  {
    title: 'Ingeniería en Software',
    description:
      'Aprende a diseñar, desarrollar y desplegar aplicaciones y sistemas robustos.',
  },
  {
    title: 'Negocios Digitales',
    description:
      'Domina el e-commerce, marketing digital y estrategias de crecimiento online.',
  },
  {
    title: 'Diseño Gráfico',
    description:
      'Conviértete en un experto en branding, ilustración y herramientas de diseño.',
  },
];

const stats = [
  { label: 'Estudiantes', value: 1200 },
  { label: 'Cursos', value: 35 },
  { label: 'Profesores', value: 25 },
];

const testimonials = [
  { name: 'Ana Pérez', text: 'OSMAR me dio las herramientas para lograr mi sueño profesional.' },
  { name: 'Luis Gómez', text: 'La flexibilidad de las clases es inigualable. ¡Recomendado!' },
  { name: 'María Rodríguez', text: 'Excelente atención y contenido de calidad.' },
];

const offers = [
  {
    title: 'Equipo Experimentado',
    description:
      'Cada uno de nosotros es maestro en nuestro oficio; tenemos años de experiencia y pasión por cada proyecto.',
  },
  {
    title: 'Calidad Inigualable',
    description:
      'Prestamos atención a cada detalle, colaborando con los mejores artesanos para garantizar excelencia.',
  },
  {
    title: 'Visionarios del Futuro',
    description:
      'No le tememos a la experimentación ni a los materiales inusuales; diseñamos el mañana hoy.',
  },
];

export default function Info() {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: 1, y: 0, transition: { staggerChildren: 0.3 } });
  }, [controls]);

  return (
    <div className="info-page">
      {/* Hero “split” con video */}
      <section className="hero-new">
        <div className="hero-text">
          <motion.p
            className="hero-intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            TU FUTURO EMPIEZA AQUÍ
          </motion.p>

          <motion.h1
            className="hero-title-large"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Descubre tu  
            <span className="accent"> nueva carrera</span>
          </motion.h1>

          <motion.div
            className="hero-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.5, duration: 0.6, ease: 'easeOut' }}
          />

          <motion.p
            className="hero-sub"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            Aprende con expertos, desde donde quieras y a tu ritmo.
          </motion.p>

          <motion.div
            className="hero-cta"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1, duration: 0.6 }}
          >
            <Link to="/register" className="btn btn-primary">
              Empieza hoy
            </Link>
          </motion.div>
        </div>

        <div className="hero-video-wrapper">
          <motion.video
            className="hero-video-new"
            src={heroVideo}
            autoPlay
            muted
            loop
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
          />
          <div className="hero-video-overlay" />
        </div>
      </section>
{/* ————————— Proceso de aprendizaje ————————— */}
<section className="process container" aria-label="Proceso de aprendizaje">
  <div className="process-left">
    <motion.h2
      className="process-title"
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      PROCESO<br/>DE APRENDIZAJE
    </motion.h2>

    <motion.span
      className="process-bar"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
    />
  </div>

  <div className="process-right">
    {[
      {
        n: '1',
        t: 'INSCRIPCIÓN',
        d: 'Crea tu cuenta, elige un plan y obtén acceso inmediato al campus virtual.'
      },
      {
        n: '2',
        t: 'EXPLORA Y ESTUDIA',
        d: 'Sigue el plan paso a paso: videos, lecturas y ejercicios con retroalimentación.'
      },
      {
        n: '3',
        t: 'EVALÚA Y CERTIFÍCATE',
        d: 'Presenta tus exámenes, obtén tu calificación y descarga tu certificado.'
      }
    ].map((s, i) => (
      <motion.article
        key={s.n}
        className="process-step"
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.15 * i }}
      >
        <div className="step-number" aria-hidden="true">{s.n}</div>
        <div className="step-content">
          <h3 className="step-title">{s.t}</h3>
          <p className="step-desc">{s.d}</p>
        </div>
      </motion.article>
    ))}
  </div>
</section>

      {/* ————————— “Lo que ofrecemos” ————————— */}
      <section className="what-we-offer">
        <div className="offer-container">
          <div className="offer-left">
            <motion.h2
              className="offer-title"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              LO QUE OFRECEMOS
            </motion.h2>
            <motion.div
              className="offer-underline"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6, ease: 'easeOut' }}
            />
          </div>

          <div className="offer-right">
            {offers.map((item, i) => (
              <motion.div
                key={i}
                className="offer-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 * i, duration: 0.6 }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="icon" />
                <div className="offer-text">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

   {/* Carreras ofrecidas — versión carrusel */}
<section className="careers container">
  <motion.h2
    className="section-title"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
    Nuestras Carreras
  </motion.h2>

  {/* duplicamos para llenar la pista si hay pocas carreras */}
  {(() => {
    const MIN = 8; // mínimo para cubrir ancho
    let list = [...careers];
    while (list.length < MIN) list = [...list, ...careers];
    const carouselItems = list.slice(0, Math.max(MIN, careers.length));

    return (
      <div
        className="carousel"
        data-mask
        style={{ '--items': carouselItems.length }}
      >
        {carouselItems.map((c, i) => (
          <article key={`${c.title}-${i}`}>
            <img
              src={
                c.image ||
                [
                  'https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=1200&auto=format&fit=crop',
                  'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?q=80&w=1200&auto=format&fit=crop',
                  'https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1200&auto=format&fit=crop',
                ][i % 3]
              }
              alt={c.title}
              loading="lazy"
            />
            <h2>{c.title}</h2>
            <div>
              <p>{c.description}</p>
              <Link to="/register">Leer más</Link>
            </div>
          </article>
        ))}
      </div>
    );
  })()}
</section>



      {/* Estadísticas */}
      <section className="stats container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Nuestros Números
        </motion.h2>
        <div className="stats-grid">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              className="stat-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 * i, duration: 0.6 }}
            >
              <CountUp end={s.value} duration={2} className="stat-value" />
              <p className="stat-label">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Testimonios */}
      <section className="testimonials container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Lo que dice nuestra comunidad
        </motion.h2>
        <motion.div
          className="testimonials-slider"
          initial="hidden"
          animate="visible"
          variants={{ hidden: {}, visible: {} }}
        >
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              className="testimonial-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 * i, duration: 0.6 }}
            >
              <p>"{t.text}"</p>
              <span>— {t.name}</span>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Características clave */}
      <section className="features container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          ¿Por qué elegir OSMAR?
        </motion.h2>
        <div className="feature-grid">
          {[
            { icon: '🎓', label: 'Docentes Expertos' },
            { icon: '⏰', label: 'Clases Flexibles' },
            { icon: '🌐', label: 'Acceso Mundial' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="feature-card"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 * i, duration: 0.6 }}
              whileHover={{ scale: 1.05 }}
            >
              <span className="icon">{f.icon}</span>
              <p>{f.label}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
